export const ApiPaths = {
    FINALIZE_SIGN_IN: 'account/authinfo',

    ASSIGN_POSTAL: 'assign/postal',
    ASSIGN: 'assign',

    GET_AUTHORIZE_CONFIG: (province) => `authorizationdata?province=${province}`,
    AUTHORIZE_BLOCK: 'authorizeblock',

    GET_SYSTEM_CONFIG: 'home',

    CONFIRM_IDENTITY: 'confirmidentity',
    CONFIRM_IDENTITY_CONFIRMATION: 'confirmidentity/confirmation',
    CONFIRM_IDENTITY_GET_CONFIRMATION: 'confirmidentity/getconfirmation',
    CONFIRM_IDENTITY_UPLOAD_FILE: 'confirmidentity/confirmation/image',
    GET_DOCV_URL: (isSpouse) => `confirmidentity/confirmation/${isSpouse}/getUrl`,
    GET_DOCV_STATUS: (verificationSessionId) => `confirmidentity/confirmation/${verificationSessionId}/getStatus`,
    COMPLETE_ID_VERIFICATION: 'confirmidentity/confirmation/completeIdVerification',

    COMPLETED_TAX_DOCUMENTS: (taxYear) => `documents/completed?taxYear=${taxYear}`,
    COMPLETED_TAX_DOCUMENTS_FOR_REVIEW: (taxYear) => `documents/review?taxYear=${taxYear}`,
    COMPLETED_TAX_DOCUMENTS_FOR_APPROVAL: (taxYear) => `documents/approval?taxYear=${taxYear}`,
    SET_FILE_VIEWED: 'documents/viewed',
    SEND_ONE_TIME_SMS: 'token',
    REDEEM_ONE_TIME_CODE: 'token/redeem',
    SET_FILE_WAS_UPLOADED: 'documents/uploaded',
    UPLOAD_STEP_COMPLETED: 'documents/upload',
    SET_APPROVAL_COMPLETE: 'documents/approval',
    SEND_REVIEW_COMPLETE: 'documents/reviewcompletemessage',
    SEND_REVIEW_COMPLETE_WITH_SIGNATURE: 'documents/reviewcompletemessagewetsignature',
    GET_SUGGESTIONS: (taxYear) => `suggesteddocs/${taxYear}`,

    GET_INTERVIEW: (taxYear) => `interview?taxYear=${taxYear}`,
    SAVE_INTERVIEW: (isComplete) => {
        let url = 'interview'
        if (isComplete != null) {
            url += `?isComplete=${isComplete ? 'true' : 'false'}`
        }
        return url
    },

    MESSAGES: 'messages',
    MESSAGES_READ: 'messages/read',
    MESSAGES_INTERNAL_NOTE_NO_PRINTER: 'messages/internalnotenoprinter',

    GET_PAYMENT_INFO: (caseid) => `case/${caseid}/payments`,
    COMPLETE_PAYMENT: 'case/payment',

    PRODUCT: 'product',
    GET_PRODUCT_ADDONS: (caseId) => `case/${caseId}/eligableProductAddons`,

    ACCOUNT: 'account',
    ACCOUNT_INFO: 'account/accountinfo',
    ACCOUNT_SIGNIN: 'auth/signin',
    ACCOUNT_SIGNOUT: 'auth/signout',
    ACCOUNT_REFRESH_TOKEN: 'auth/refreshtoken',
    ACCOUNT_CONVERSATION: 'account/conversation',
    ACCOUNT_LANGUAGE: (langPref) => `account/lang?langPref=${langPref}`,
    ACCOUNT_ADD_VAROLE: 'auth/addvarole',

    CASE: 'case',
    DELETE_CASE: (taxYear) => `case/${taxYear}`,

    GET_SIGNED_DOCUMENTS: 'esignature',
    SIGN_DOCUMENT: 'esignature/sign',
    COMPLETE_DOCUMENT_SIGNING: 'esignature/complete',
    TRANSFER_DOCUMENT_SIGNING: 'esignature/completefiles',
    CANCEL_SIGNING: 'esignature/cancelinprogress',

    SURVEY: 'survey',

    GET_TOKEN: 'public/token',

    CASE_STATE_SETTINGS: 'casestate/settings',
    CASE_STATE_SYNCHRONIZE: (synchronize) => {
        let url = 'casestate';
        if(synchronize) {
            url += '?synchronize=true';
        }
        return url;
    },
    CASE_STATE_LAST_REVIEWED: 'casestate/lastreviewed',
    CASE_STATE_NOTIFY_ON_SCHEDULE_CALL: 'casestate/notifyonschedulecall',

    DIRECT: 'direct',

    UPLOAD_DOCUMENT: 'clientdocumentmanagement',
    DOCUMENT: (documentId) => `clientdocumentmanagement/${documentId}`,
    LIST_DOCUMENTS: (taxYear, pageIndex) => `clientdocumentmanagement?taxYear=${taxYear}&page=${pageIndex}`,
};